import React, { useState } from 'react';
import Modal from '../../../elements/Modal';
import { useQuery } from '@apollo/client';
import { FILE_UPLOAD } from './queries';
import DataState from 'app/src/components/DataState';
import FileDownload from 'js-file-download';


const containerStyle = {
  display: 'block',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '600px',
  maxWidth: '100%'
};

const UploadPreview = props => {
  const { show, setShow, id } = props;
  const { loading, error, data } = useQuery(FILE_UPLOAD, { variables: { id: parseInt(id) } });

  if (error) return <DataState.Error error={error} />;
  if (!data) return <DataState.Loading />;

  const download = () => {
    if(data?.fileUpload?.fileUrl.includes('.pdf')) {
      setShow(false);
      window.open(data?.fileUpload.fileUrl, '_blank');
    }
  }

  return (
    <>
      {data && !data?.fileUpload?.fileUrl.includes('.pdf') ?
        <Modal
          showModal={show}
          setShowModal={setShow}
          modalType={'File Upload'}
        >
          <a href={data.fileUpload.fileUrl} target="_blank">
            Open in New Window
          </a>
          <br />
          <img src={data.fileUpload.fileUrl} style={containerStyle} />
        </Modal> :
        null
      }
      {data && data?.fileUpload?.fileUrl.includes('.pdf') ?
        download() : null
      }
    </>
  )
}

export default UploadPreview;
